import React from "react";
import { NavLink } from "react-router-dom";

import { useOrgModParams } from "src/features/orgmod/hooks";

type OrgModLinkProps = Omit<React.ComponentProps<typeof NavLink>, "to"> & {
	to: string;
};

export const OrgModLink: React.FunctionComponent<OrgModLinkProps> = ({
	to,
	...props
}) => {
	const { org, mod } = useOrgModParams();
	return (
		<NavLink to={`/${org}/${mod}/${to.replace(/^\//, "")}`} {...props} />
	);
};
